import axiosConfig from '../axiosConfig';
import store from "../storeConfig";
import Moment from "moment";

import axios from "axios";
import { useSelector } from 'react-redux';

import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";

const baseURL = getEnvVars().apiUrl;

var axi = axios.create({
  baseURL: baseURL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

async function processTransactionsByDate(transactions) {

    var output = {};
    var sumInvested = 0;
    var sumDonated = 0;

    var activeCategories = [];

    const userPartners = store.getState().user.userData.partners;
    var sumPending = 0;

    transactions.forEach(element => {

if (element.creationDate !== undefined){
    if (element.creationDate === '' || element.creationDate === null){
        element.eventDate = '1970-01-01T01:00:00Z';
    } else {
    element.eventDate = element.creationDate;
    }
}
// console.log(element);

        var elementDateString = Moment(element.eventDate, "YYYY-MM-DDhh:mm:ssZZ").format();
        var elementDate = new Date(elementDateString);
        elementDate = elementDate.toISOString().slice(0,10);
        // console.log(elementDate);
        var cat_item = { id: element.partnerCategoryId,
                         name: element.partnerCategoryName}
        if (activeCategories.find(innerEl => innerEl.name == element.partnerCategoryName) === undefined) {
            activeCategories.push(cat_item);
        }
        // activeCategories[element.partnerCategoryName] = element.partnerCategoryId;
        element.amountInvested = Number.parseFloat(element.amountInvested);
        element.amountDonated = Number.parseFloat(element.amountDonated);
        sumInvested = sumInvested + element.amountInvested;
        sumDonated = sumDonated + element.amountDonated;
        if (element.transactionState === 'pending' || element.transactionState === 'Pending')
            sumPending = sumPending + element.amountInvested;
        if (output[elementDate] !== undefined) {
            output[elementDate].data.push(element);
        } else {
            var t_arr = {};
            t_arr.title = Moment(element.eventDate, "YYYY-MM-DD hh:mm:ssZZ").format("D MMM YYYY");
            t_arr.data = [];
            t_arr.data.push(element);
            output[elementDate] = t_arr;
        }
    });
    store.dispatch({
        type: 'PROCESS_TRANSACTIONS',
        transactions: output,
        invested: sumInvested,
        donated: sumDonated,
        sumPending: sumPending,
        categoryList: activeCategories,
        transactionsLoaded: true
    })
}

export function loadTransactions() {
    Auth.currentSession().then( (cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
          });
    
        try {
            axi.post('/gettransactions').then(result => {
                // console.log(result);
                if(result.data.value === null) {
                    store.dispatch({
                        type: 'LOAD_TRANSACTIONS',
                        transactions: []
                    })
                    processTransactionsByDate([]);
                } else {
                    store.dispatch({
                        type: 'LOAD_TRANSACTIONS',
                        transactions: result.data.value
                    })
                    processTransactionsByDate(result.data.value);
                }
            })
        } catch (error) {
            // console.log(error)
            return Object.assign({}, state, {
                transactions: error,
                cardsLoaded: false
            })
        }
    });
}

export function setTransactionFilter(newFilterState, newDateOutOfMonth) {
    store.dispatch({
        type: 'SET_TRANSACTION_FILTER',
        transactionsFilter: newFilterState
    })
    if(newDateOutOfMonth == true) {
        // We need to fetch new data - DEMO API doesn't support / have data for this so instead we just load ALL
        try {
            axiosConfig().post('v1/GetTransactions').then(result => {
                // console.log(result);
                store.dispatch({
                    type: 'LOAD_TRANSACTIONS',
                    transactions: result.data.transactions
                })

                var tr = filterTransactions(result.data.transactions)

                processTransactionsByDate(tr);
            })
        } catch (error) {
            // console.log(error);
        }
    } else {
        var tr = store.getState().transaction.transactionsA;
        // console.log(tr);
        tr = filterTransactions(newFilterState, tr);
        // console.log(tr);
        processTransactionsByDate(tr);
    }
}

function filterTransactions(filter, transactions){
    var ret = transactions;
    if(filter.categoryFilter != -1) {
        ret = ret.filter(t => t.partnerCategoryId === filter.categoryFilter);
    }
    if(filter.dateFilterStart != -1) {
        ret = ret.filter(t => new Date(Moment(t.eventDate, "YYYY-MM-DD hh:mm:ss").format()) > filter.dateFilterStart);
    }
    if(filter.dateFilterEnd != -1) {
        ret = ret.filter(t => new Date(Moment(t.eventDate, "YYYY-MM-DD hh:mm:ss").format()).getTime() < filter.dateFilterEnd);
    }
    if(filter.valueFilterLow != -1) {
        ret = ret.filter(t => t.totalAmountPaid >= filter.valueFilterLow);
    }
    if(filter.valueFilterHigh != -1) {
        ret = ret.filter(t => t.totalAmountPaid <= filter.valueFilterHigh);
    }
    return ret;
}

export function withdrawlRequest(payload) {
    // var payload = {
    //     amount: amount
    //   };
    Auth.currentSession().then( (cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
          });
      axi.post('/banking/withdrawlrequest', payload).then(result => {
        // console.log(result);
      });
    });
}

export function unloadTransactions() {
    store.dispatch({
        type: 'UNLOAD_TRANSACTIONS'
    })
}